import { Pipe, PipeTransform } from '@angular/core'
import { SaleItem } from '../sale-item'
import { AppState } from '../../../../core/core.state'
import { Store } from '@ngrx/store'
import { productSelectors } from '../../../product/product.selectors'
import { map } from 'rxjs/operators'
import { combineLatest, Observable } from 'rxjs'
import { Product } from '../../../product/product'
import { bookingSelectors } from '../../../booking/booking.selectors'
import { participationSelectors } from '../../../booking/participation/participation.selectors'

interface SaleItemGroupByProduct {
  productId: number
  description: string
  resources: string
  saleItems: Partial<SaleItem>[]
}

@Pipe({
  name: 'saleItemsGroupByProduct',
  pure: true
})
export class SaleItemsGroupByProductPipe implements PipeTransform {
  constructor(private store: Store<AppState>) {}

  productEntities$ = this.store.select(productSelectors.selectEntities)

  transform(value: Partial<SaleItem>[]): Observable<SaleItemGroupByProduct[]> {
    return combineLatest([
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectEntities),
      this.store.select(participationSelectors.selectAll)
    ]).pipe(
      map(([productEntities, bookingEntities, participations]) => {
        const getSaleItemResources = (saleItem) => {
          const saleItemParticipations = participations.filter(
            (p) => p.saleItemId == saleItem.id
          )

          if (!saleItemParticipations?.length) {
            return []
          }

          const saleItemBookings = saleItemParticipations?.map(
            (participation) => bookingEntities[participation.bookingId]
          )

          if (!saleItemBookings?.length) {
            return []
          }

          const productIds = saleItemBookings
            .filter((b) => Boolean(b))
            .map((b) => b.productId)

          if (!productIds) {
            return []
          }
          const uniqueProductIds = [...new Set(productIds?.filter(Boolean))]

          return uniqueProductIds.map(
            (productId) => productEntities?.[productId]
          )
        }
        const result: SaleItemGroupByProduct[] = []
        value.forEach((saleItem) => {
          const saleItemGroupByProduct = result.find(
            (item) => item.productId === saleItem.productId
          )
          if (saleItemGroupByProduct) {
            saleItemGroupByProduct.resources =
              saleItemGroupByProduct.resources.concat(
                getSaleItemResources(saleItem).join(' ')
              )
            saleItemGroupByProduct.saleItems.push(saleItem)
          } else {
            result.push({
              productId: saleItem.productId,
              description: productEntities[saleItem.productId]?.description,
              resources: getSaleItemResources(saleItem)
                .map((p) => p?.description)
                .join(' '),
              saleItems: [saleItem]
            })
          }
        })

        return result.sort((a, b) =>
          a?.description
            ?.toLowerCase()
            .localeCompare(b?.description?.toLowerCase())
        )
      })
    )
  }
}
